import { Graphics, useTick } from '@inlet/react-pixi';
import { useCallback, useState } from 'react';
import * as PIXI from 'pixi.js';
import { getGlobal } from 'store';
import { useSelector } from 'react-redux';
import { CustomPixiContainer } from 'components/CustomPixiContainer';

export const PixiSpinner = () => {
  const [rot, setRot] = useState(0);
  const [persent, setPersent] = useState(0);
  const { height, width } = useSelector(getGlobal);

  useTick(() => {
    setRot((r) => r + 0.12);
    setPersent(Math.abs(Math.sin(Date.now() / 1000)));
  });

  const draw = useCallback(
    (g: PIXI.Graphics) => {
      g.clear();
      g.lineStyle(4, 0xffffff, 1);
      g.moveTo(width / 4, 0);
      g.arc(0, 0, width / 4, 0, Math.PI * 2 * persent, false);
    },
    [persent, width]
  );

  return (
    <CustomPixiContainer x={0} y={0} width={width} height={height}>
      <Graphics rotation={rot} draw={draw} x={width / 2} y={height / 2} />
    </CustomPixiContainer>
  );
};
